import { FC, useRef, useState } from 'react'

import useIntersection from 'hooks/useIntersection'

interface ImgBaseProps {
  alt: string
  width: string
  height: string
  loading?: 'eager' | 'lazy'
  className?: string
  onLoad?: () => void
  onError?: () => void
  onClick?: () => void
}

interface ImageWithLazyProps extends ImgBaseProps {
  src?: string
}

export interface ImageProps extends ImgBaseProps {
  src: string
}

// check if the browser has native support for loading lazy
const hasLazySupport = 'loading' in HTMLImageElement.prototype

// Image component using Intersection Observer Hook for lazy loading
const ImageWithLazy: FC<ImageWithLazyProps> = (props) => {
  const { src } = props
  const ref = useRef<HTMLImageElement>(null)
  const [isLoaded, setIsLoaded] = useState<undefined | true>(undefined)

  useIntersection(ref, () => setIsLoaded(true))

  // eslint-disable-next-line jsx-a11y/alt-text
  return <img {...props} ref={ref} src={isLoaded && src} />
}

export const Image: FC<ImageProps> = (props) => {
  const { loading } = props

  if (!hasLazySupport && loading === 'lazy') {
    return <ImageWithLazy {...props} />
  }

  // eslint-disable-next-line jsx-a11y/alt-text
  return <img {...props} />
}

export default Image
